// External
import React, { useState } from "react";
import _ from "lodash";
import { compose, graphql } from "lib/apolloClient";

// Design system
import withLoader from "UIComponents/GqlWithLoader";

// Relative
import TemplateVersionHistoryTable from "./components/TemplateVersionHistoryTable/TemplateVersionHistoryTable";
import TemplateVersionChangesTable from "./components/TemplateVersionChangesTable/TemplateVersionChangesTable";
import {
  getTemplateVersionChangesQuery,
  getTemplateVersionHistoryQuery,
} from "./modules/TemplateLogsModalQueries";

// Constants
import {
  TEMPLATE_HISTORY_VIEW,
  TEMPLATE_HISTORY_CHANGES_VIEW,
} from "./modules/TemplateLogsModalConstants";

const TemplateLogsModal = props => {
  const {
    templateVersionHistory,
    templateVersionChanges,
    selectedVersionId,
    handleSelectedVersionIdChange,
  } = props;

  const currentView = _.isEmpty(selectedVersionId)
    ? TEMPLATE_HISTORY_VIEW
    : TEMPLATE_HISTORY_CHANGES_VIEW;

  const handleVersionRowClick = versionId => {
    handleSelectedVersionIdChange(versionId);
  };

  const handleGoBackToTemplateVersionHistory = () => {
    handleSelectedVersionIdChange(null);
  };

  switch (currentView) {
    case TEMPLATE_HISTORY_CHANGES_VIEW:
      return (
        <TemplateVersionChangesTable
          templateVersionChanges={templateVersionChanges}
          templateVersionHistory={templateVersionHistory}
          selectedVersionId={selectedVersionId}
          onBack={handleGoBackToTemplateVersionHistory}
        />
      );

    case TEMPLATE_HISTORY_VIEW:
    default:
      return (
        <TemplateVersionHistoryTable
          templateVersionHistory={templateVersionHistory}
          onRowClick={handleVersionRowClick}
        />
      );
  }
};

const TemplateLogsModalHOC = compose(
  graphql(getTemplateVersionHistoryQuery, {
    name: "getTemplateVersionHistoryQuery",
    options: ({ data }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          input: {
            id: data.progressReportTemplateId,
          },
        },
      };
    },
    props: ({
      getTemplateVersionHistoryQuery,
      ownProps: { isData, isLoading },
    }) => {
      const queryData = _.get(
        getTemplateVersionHistoryQuery,
        "documentation",
        {}
      );
      const templateVersionHistory = _.get(
        queryData,
        "internalToolsData.progressReport.templateVersionHistory",
        []
      );

      return {
        templateVersionHistory,
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          _.get(getTemplateVersionHistoryQuery, "networkStatus") == 1 ||
          _.get(getTemplateVersionHistoryQuery, "networkStatus") == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getTemplateVersionChangesQuery, {
    name: "getTemplateVersionChangesQuery",
    skip: ({ selectedVersionId }) => _.isEmpty(selectedVersionId),
    options: ({ selectedVersionId }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          input: {
            id: selectedVersionId,
          },
        },
      };
    },
    props: ({
      getTemplateVersionChangesQuery,
      ownProps: { isData, isLoading },
    }) => {
      const queryData = _.get(
        getTemplateVersionChangesQuery,
        "documentation",
        {}
      );
      const templateVersionChanges = _.get(
        queryData,
        "internalToolsData.progressReport.templateVersionChanges",
        []
      );

      return {
        templateVersionChanges,
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          _.get(getTemplateVersionChangesQuery, "networkStatus") == 1 ||
          _.get(getTemplateVersionChangesQuery, "networkStatus") == 2 ||
          isLoading,
      };
    },
  }),
  withLoader
)(TemplateLogsModal);

const TemplateLogsModalWrapper = ({ data }) => {
  const [selectedVersionId, setSelectedVersionId] = useState(null);

  const handleSelectedVersionIdChange = versionId => {
    setSelectedVersionId(versionId);
  };

  return (
    <TemplateLogsModalHOC
      data={data}
      selectedVersionId={selectedVersionId}
      handleSelectedVersionIdChange={handleSelectedVersionIdChange}
      isData={true}
      isLoading={false}
    />
  );
};

export default TemplateLogsModalWrapper;
